import { Panel } from "@fluentui/react"
import { IOpenPanel } from "../../Interfaces/IPanel";
import { useCallback, useEffect } from "react";
import { PanelHeaderBasic } from "./PanrlHeaderBasic";
import { MessageBarResponse } from "../MessageBarResponse/MessageBarResponse";
import { ProgressBarLoading } from "../ProgressBarLoading/ProgressBarLoading";
import { codigosRespuesta } from "../../Interfaces/base/IResponse";
interface IPanel9 {
    isOpen: boolean;
    onDismiss?: () => void;
    onRenderFooter?: () => JSX.Element;
    children?: any;
    textHeader:string
    subTextHeader?:string
    status: codigosRespuesta,
    mensaje: string,
    loading:boolean
    
 }
export const PanelDrawer=(props:IPanel9)=>{
   const onRenderHeader = useCallback(
      () => (
        <PanelHeaderBasic
        subTextHeader={props.subTextHeader??""}
        textHeader={props.textHeader}
      />
      ),
      [props.isOpen]
    );
   return(
    <Panel
    isOpen={props.isOpen}
    onDismiss={props.onDismiss}
    onRenderHeader={onRenderHeader}
    isFooterAtBottom
    onRenderFooter={props.onRenderFooter}
    >
   <div hidden={props.mensaje == ""}>
   <MessageBarResponse
      objetoResponse={{ codigo: props.status, mensaje: props.mensaje }}
      close={true}
   />
   </div>
   <div hidden={!props.loading}>
      <ProgressBarLoading></ProgressBarLoading>
   </div>
   <div hidden={props.loading}>
       {!props.mensaje && ( 
         <>
         {props.children}
         </>
       )}
   </div>
    </Panel>
   )
}